//Tabs Navigation
const FORM_LABELS = Object.freeze({
    email: 'E-mail',
    password: 'password',
    phone: 'Телефон',
    mobile_number: 'Моб. номер',
    sms_code: 'Код из смс',
    lastname: 'Фамилия',
    firstname: 'Имя',
    patronymic: 'Отчество',
    city: 'Город',
    settlement_name: 'Населенный пункт',
    area_code: 'Индекс',
    street: 'Улица',
    building: 'Дом',
    house_body: 'Корпус/строение',
    apartment: 'Квартира',
    passport: {
        series: 'Серия паспорта',
        number: 'Номер паспорта',
        issued_date: 'Дата выдачи',
        issued_by: 'Кем выдан',
        subdivision_code: 'Код подразделения',
        registration_address: 'Адрес регистрации',
        photo_upload: 'Фото паспорта главного разворота',
        photo_registration_upload: 'Фото паспорта прописки/регистрации',
    },
    inn: 'ИНН',
    personal_data_processing_agreement: 'Согласие на обработку персональных данных',
    personal_data_share_agreement: 'Согласие на передачу персональных данных',
    event_conditions: 'Согласен с условиями проведения мероприятия',
    enter_phone_number: 'Введите номер телефона',
    enter_sms_code: 'Введите код из СМС',
})

const FORM_BUTTONS = Object.freeze({
    enter: 'войти',
    send: 'отправить',
    upload_passport_photo: 'Загрузить фото паспорта',
    check: 'Проверить',
    send_code: 'Отправить код',
})

export {
    FORM_LABELS,
    FORM_BUTTONS,
}